export const commonEnGb = {
  brand: {
    logoAlt: 'Safi logo',
    name: 'Safi',
    vatLabel: 'Safi VAT',
  },
  domains: {
    evidence: 'Evidence',
    evidenceLower: 'evidence',
    qualityControl: 'Quality control',
    qualityControlLower: 'quality control',
  },
  currencySelectField: {
    groups: {
      other: 'Other',
      suggested: 'Suggested',
    },
  },
} as const;
